import {ApiRequestor} from "@/classes/requestors/api.requestor";

export class DtoApiImportPersonsRequest extends ApiRequestor {
  $import (payload) {
    return this.$http('POST', 'persons/import', {payload});
  }
}
